import { memo } from 'react'
import { Path, Svg } from 'react-native-svg'

interface SvgIconProps {
  color?: string
  size?: number
}

export const SvgTriangle = memo(
  ({ color = '#F7F6ED', size = 24 }: SvgIconProps) => (
    <Svg width={size} height={size} viewBox="0 0 13 14" fill="none">
      <Path
        d="M10.0404 4.65017C11.2857 5.37136 11.9083 5.73195 12.1173 6.20273C12.2996 6.61336 12.2996 7.08229 12.1173 7.49292C11.9083 7.9637 11.2857 8.32429 10.0404 9.04549L3.79479 12.6625C2.54948 13.3837 1.92682 13.7443 1.41589 13.6904C0.970225 13.6434 0.56537 13.4089 0.301975 13.0453C-9.42446e-08 12.6284 -6.27978e-08 11.9072 0 10.4648L3.15293e-07 3.23084C3.78148e-07 1.78846 4.08393e-07 1.06727 0.301975 0.65036C0.565371 0.286712 0.970226 0.0522504 1.41589 0.00526557C1.92682 -0.0486011 2.54948 0.311995 3.79479 1.03319L10.0404 4.65017Z"
        fill={color}
      />
    </Svg>
  ),
)

SvgTriangle.displayName = 'SvgTriangle'
